export default {

  // home is a section without childs, set as an empty array
  home: [],

  avisos: [],

  eventos: [],

  sugerencias: [],

  adminConfig: []

};
